module.exports = __webpack_public_path__ + "static/media/step5.52b39a3f.svg";